import React, { createContext, useState } from 'react';

import PropTypes from 'prop-types';

const GeneralContext = createContext();

function GeneralProvider({ children }) {
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [infoMessage, setInfoMessage] = useState('');
  const [warningMessage, setWarningMessage] = useState('');
  const [acessToken, setAcessToken] = useState('');
  const [sideMenu, setSideMenu] = useState('reversa');
  const [idMenuSelected, setIdMenuSelected] = useState('home');
  const [loading, setLoading] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [store, setStore] = useState(null);

  return (
    <GeneralContext.Provider
      value={{
        idMenuSelected,
        setIdMenuSelected,

        acessToken,
        setAcessToken,

        successMessage,
        setSuccessMessage,

        errorMessage,
        setErrorMessage,

        infoMessage,
        setInfoMessage,

        warningMessage,
        setWarningMessage,

        sideMenu,
        setSideMenu,

        loading,
        setLoading,

        menuOpen,
        setMenuOpen,

        user,
        setUser,

        store,
        setStore,
      }}
    >
      {children}
    </GeneralContext.Provider>
  );
}

export { GeneralContext, GeneralProvider };

GeneralProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
